import { Page, Text, View, Document, Image } from '@react-pdf/renderer';
import { styles } from './generate-pdf-styles';
import { IPractices } from '../../interfaces/IGenericResult';

export const GeneratePdf = (data: any, googleMapUrl: string) => {
  console.log('DATA', data);
  console.log('IMAGE VALUE', googleMapUrl);
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* <View>
          <Image src="https://simpra.com/wp-content/uploads/2023/06/Simpra-_Healthplan_-Logo.png" style={{ width: '200px' }} />
        </View> */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>{data.name}</Text>

          <View style={{ display: 'flex', flexDirection: 'row' }}>
            <Text style={styles.title}>NPI: </Text>
            <Text style={styles.content}>{data.providerNPI}</Text>
          </View>

          <View style={{ display: 'flex', flexDirection: 'row' }}>
            <Text style={styles.title}>Specialty: </Text>
            <Text style={styles.content}>{data.specialty}</Text>
          </View>

          <View style={{ display: 'flex', flexDirection: 'row' }}>
            <Text style={styles.title}>Phone: </Text>
            <Text style={styles.content}>{data.phone}</Text>
          </View>

          <View style={{ display: 'flex', flexDirection: 'row' }}>
            <Text style={styles.title}>Fax: </Text>
            <Text style={styles.content}>{data.fax}</Text>
          </View>

          <View style={{ display: 'flex', flexDirection: 'row' }}>
            <Text style={styles.title}>Medical Group Name: </Text>
            <Text style={styles.content}>{data.practices}</Text>
          </View>

          <View style={{ display: 'flex', flexDirection: 'row' }}>
            <Text style={styles.title}>Distance: </Text>
            <Text style={styles.content}>{data.miles} mi</Text>
          </View>

          <View style={{ marginTop: '10px', marginBottom: '10px' }}>
            <Image src={googleMapUrl} style={{ width: '350px', height: '350px' }} />
          </View>

          <Text style={{ marginBottom: '10px' }}>Locations: </Text>
          <View style={styles.practices}>
            {data.practicesArray.map((item: IPractices, index: number) => (
              <View key={index} style={styles.practices}>
                <Text>
                  {index + 1}. {item.practice}
                </Text>
                <Text>{item.addressLine1}</Text>
                <Text>
                  {item.city}, {item.state} {item.zipCode}
                </Text>
                <Text>Phone: {item.phone}</Text>
                <Text>Fax: {item.fax}</Text>
              </View>
            ))}
          </View>
        </View>
      </Page>
    </Document>
  );
};
